// App-wide brand lockup: "Stage Door" in a solid maroon box so it stays crisp
// on the plaid header in both light and dark modes. Tagline shows only where asked.
export const BrandLockup = ({ showTagline = false, onClick, size = "md", className = "", testid = "brand-lockup" }) => {
  const lg = size === "lg";
  const inner = (
    <>
      <div className={`flex items-center justify-center overflow-hidden rounded-md bg-white/95 shadow-inner ring-1 ring-black/10 ${lg ? "h-9 w-9" : "h-7 w-7"}`}>
        <img src="/plaid.jpg" alt="" className="h-full w-full scale-110 object-cover" />
      </div>
      <div className="text-left leading-none">
        <span className={`block font-display font-800 tracking-tight text-white ${lg ? "text-xl" : "text-[15px]"}`}>Stage Door</span>
        {showTagline && (
          <span className={`block font-700 uppercase tracking-[0.14em] text-white/75 ${lg ? "mt-1.5 text-[10px]" : "mt-1 text-[9px]"}`}>VIP All-In-One</span>
        )}
      </div>
    </>
  );
  const box = `inline-flex items-center rounded-xl bg-[#9B2226] shadow-lg ring-1 ring-black/15 ${lg ? "gap-3 px-4 py-2.5" : "gap-2.5 px-3 py-2"}`;
  if (onClick) {
    return (
      <button onClick={onClick} className={`${box} transition-transform hover:scale-[1.02] active:scale-95 ${className}`} data-testid={testid} aria-label="Stage Door">
        {inner}
      </button>
    );
  }
  return <div className={`${box} ${className}`} data-testid={testid}>{inner}</div>;
};
